const CACHE_TTL_MS = 10 * 60 * 1000;

const cache = new Map();

function getEntry(auctionId) {
  const entry = cache.get(auctionId);
  if (!entry || entry.expiresAt <= Date.now()) return null;
  return entry;
}

function setEntry(auctionId, fields) {
  const existing = getEntry(auctionId);
  cache.set(auctionId, {
    ...existing,
    ...fields,
    expiresAt: Date.now() + CACHE_TTL_MS,
  });
}

export function setOneTimeMaxBiddingEnabledForSeller(auctionId, isEnabled) {
  setEntry(auctionId, { isOneTimeMaxBiddingFeatureEnabledForSeller: isEnabled });
}

export function isOneTimeMaxBiddingEnabledForSellerCached(auctionId) {
  const entry = getEntry(auctionId);
  return !!entry?.isOneTimeMaxBiddingFeatureEnabledForSeller;
}

export function setMinProxyValidationEnabledForSeller(auctionId, isEnabled) {
  setEntry(auctionId, { isMinProxyValidationFeatureEnabledForSeller: isEnabled });
}

export function isMinProxyValidationEnabledForSellerCached(auctionId) {
  const entry = getEntry(auctionId);
  return !!entry?.isMinProxyValidationFeatureEnabledForSeller;
}

export function isSellerInfoCached(auctionId) {
  return !!getEntry(auctionId);
}

export function clearSellerInfoCache() {
  cache.clear();
}
